// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cUYt","name":"styles_name__3U-nv","phone":"styles_phone__2eRQ0"};